module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-08-04",
		"endpointPrefix": "firehose",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Firehose",
		"serviceFullName": "Amazon Kinesis Firehose",
		"signatureVersion": "v4",
		"targetPrefix": "Firehose_20150804"
	},
	"operations": {
		"CreateDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"S3DestinationConfiguration": {
						"shape": "S3"
					},
					"RedshiftDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"ClusterJDBCURL",
							"CopyCommand",
							"Username",
							"Password",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sl"
							},
							"Username": {
								"shape": "Sp"
							},
							"Password": {
								"shape": "Sq"
							},
							"RetryOptions": {
								"shape": "Sr"
							},
							"S3Configuration": {
								"shape": "S3"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Sf"
							}
						}
					},
					"ElasticsearchDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"DomainARN",
							"IndexName",
							"TypeName",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "Sy"
							},
							"RetryOptions": {
								"shape": "S11"
							},
							"S3BackupMode": {},
							"S3Configuration": {
								"shape": "S3"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Sf"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeliveryStreamARN": {}
				}
			}
		},
		"DeleteDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartDestinationId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamDescription"
				],
				"members": {
					"DeliveryStreamDescription": {
						"type": "structure",
						"required": [
							"DeliveryStreamName",
							"DeliveryStreamARN",
							"DeliveryStreamStatus",
							"VersionId",
							"Destinations",
							"HasMoreDestinations"
						],
						"members": {
							"DeliveryStreamName": {},
							"DeliveryStreamARN": {},
							"DeliveryStreamStatus": {},
							"VersionId": {},
							"CreateTimestamp": {
								"type": "timestamp"
							},
							"LastUpdateTimestamp": {
								"type": "timestamp"
							},
							"Destinations": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"DestinationId"
									],
									"members": {
										"DestinationId": {},
										"S3DestinationDescription": {
											"shape": "S1i"
										},
										"RedshiftDestinationDescription": {
											"type": "structure",
											"required": [
												"RoleARN",
												"ClusterJDBCURL",
												"CopyCommand",
												"Username",
												"S3DestinationDescription"
											],
											"members": {
												"RoleARN": {},
												"ClusterJDBCURL": {},
												"CopyCommand": {
													"shape": "Sl"
												},
												"Username": {
													"shape": "Sp"
												},
												"RetryOptions": {
													"shape": "Sr"
												},
												"S3DestinationDescription": {
													"shape": "S1i"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Sf"
												}
											}
										},
										"ElasticsearchDestinationDescription": {
											"type": "structure",
											"members": {
												"RoleARN": {},
												"DomainARN": {},
												"IndexName": {},
												"TypeName": {},
												"IndexRotationPeriod": {},
												"BufferingHints": {
													"shape": "Sy"
												},
												"RetryOptions": {
													"shape": "S11"
												},
												"S3BackupMode": {},
												"S3DestinationDescription": {
													"shape": "S1i"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Sf"
												}
											}
										}
									}
								}
							},
							"HasMoreDestinations": {
								"type": "boolean"
							}
						}
					}
				}
			}
		},
		"ListDeliveryStreams": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartDeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamNames",
					"HasMoreDeliveryStreams"
				],
				"members": {
					"DeliveryStreamNames": {
						"type": "list",
						"member": {}
					},
					"HasMoreDeliveryStreams": {
						"type": "boolean"
					}
				}
			}
		},
		"PutRecord": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Record"
				],
				"members": {
					"DeliveryStreamName": {},
					"Record": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RecordId"
				],
				"members": {
					"RecordId": {}
				}
			}
		},
		"PutRecordBatch": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Records"
				],
				"members": {
					"DeliveryStreamName": {},
					"Records": {
						"type": "list",
						"member": {
							"shape": "S1q"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"FailedPutCount",
					"RequestResponses"
				],
				"members": {
					"FailedPutCount": {
						"type": "integer"
					},
					"RequestResponses": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RecordId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"UpdateDestination": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"CurrentDeliveryStreamVersionId",
					"DestinationId"
				],
				"members": {
					"DeliveryStreamName": {},
					"CurrentDeliveryStreamVersionId": {},
					"DestinationId": {},
					"S3DestinationUpdate": {
						"shape": "S23"
					},
					"RedshiftDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sl"
							},
							"Username": {
								"shape": "Sp"
							},
							"Password": {
								"shape": "Sq"
							},
							"RetryOptions": {
								"shape": "Sr"
							},
							"S3Update": {
								"shape": "S23"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Sf"
							}
						}
					},
					"ElasticsearchDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "Sy"
							},
							"RetryOptions": {
								"shape": "S11"
							},
							"S3Update": {
								"shape": "S23"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Sf"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "S7"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Sb"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Sf"
				}
			}
		},
		"S7": {
			"type": "structure",
			"members": {
				"SizeInMBs": {
					"type": "integer"
				},
				"IntervalInSeconds": {
					"type": "integer"
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"NoEncryptionConfig": {},
				"KMSEncryptionConfig": {
					"type": "structure",
					"required": [
						"AWSKMSKeyARN"
					],
					"members": {
						"AWSKMSKeyARN": {}
					}
				}
			}
		},
		"Sf": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"LogGroupName": {},
				"LogStreamName": {}
			}
		},
		"Sl": {
			"type": "structure",
			"required": [
				"DataTableName"
			],
			"members": {
				"DataTableName": {},
				"DataTableColumns": {},
				"CopyOptions": {}
			}
		},
		"Sp": {
			"type": "string",
			"sensitive": true
		},
		"Sq": {
			"type": "string",
			"sensitive": true
		},
		"Sr": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"Sy": {
			"type": "structure",
			"members": {
				"IntervalInSeconds": {
					"type": "integer"
				},
				"SizeInMBs": {
					"type": "integer"
				}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"S1i": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN",
				"BufferingHints",
				"CompressionFormat",
				"EncryptionConfiguration"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "S7"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Sb"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Sf"
				}
			}
		},
		"S1q": {
			"type": "structure",
			"required": [
				"Data"
			],
			"members": {
				"Data": {
					"type": "blob"
				}
			}
		},
		"S23": {
			"type": "structure",
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "S7"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Sb"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Sf"
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/firehose-2015-08-04.min.json
 ** module id = 1320
 ** module chunks = 0
 **/